import React from "react";
import { FONT_COLOR, FONT_SIZE, PaddedContainer, Text } from "@disco/disco_core";

import "../LeadGen/lead-gen-header.css";
import accessibilityProvider from "../../utils/accessibilityProvider";
import useCustomization, {
    CUSTOMIZATION_DETAIL,
    CUSTOMIZATION_TYPE,
} from "../../hooks/useCustomization";

const EngageHeader = () => {
    const { applyCustomizationOrFallback } = useCustomization();

    const primaryHeading = applyCustomizationOrFallback(
        CUSTOMIZATION_DETAIL[CUSTOMIZATION_TYPE.CHECKOUT].WIDGET_HEADING,
        "Your order comes with rewards"
    );

    const secondaryHeading = applyCustomizationOrFallback(
        CUSTOMIZATION_DETAIL[CUSTOMIZATION_TYPE.CHECKOUT].WIDGET_SUBHEADING,
        "Unlock exclusive offers before they’re gone"
    );

    return (
        <PaddedContainer flexContent>
            <PaddedContainer marginRight={"auto"}>
                <Text
                    size={FONT_SIZE.SUB_TITLE}
                    className="lead-gen-header-title"
                    {...accessibilityProvider({
                        role: "heading",
                        name: primaryHeading,
                        level: 1,
                    })}
                >
                    {primaryHeading}
                </Text>
                <Text
                    size={FONT_SIZE.BODY}
                    color={FONT_COLOR.MID}
                    {...accessibilityProvider({
                        role: "heading",
                        name: secondaryHeading,
                        level: 2,
                    })}
                >
                    {secondaryHeading}
                </Text>
            </PaddedContainer>
        </PaddedContainer>
    );
};
export default EngageHeader;
